import { createSlice } from '@reduxjs/toolkit';

export const PensionSlice = createSlice({
    name: 'pension',
    initialState: {
        pension_list: [],
        pension_list_select: []
    },
    reducers: {
        setPensionRedux: ( state, { payload } ) => {
            state.pension_list  =  payload;
        },
        setPensionSelectRedux: ( state, { payload } ) => {
            state.pension_list_select  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setPensionRedux, setPensionSelectRedux } = PensionSlice.actions;